module.exports = __webpack_public_path__ + "img/mx_seguromultidispositivo.bd1d75f0.png";